var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }